import { render } from "./UIPanel.vue?vue&type=template&id=bdb64f42&scoped=true"
const script = {}

import "./UIPanel.vue?vue&type=style&index=0&id=bdb64f42&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb64f42"]])

export default __exports__